import { render, staticRenderFns } from "./UserRoleSelect.vue?vue&type=template&id=2aa7a696&scoped=true&"
import script from "./UserRoleSelect.vue?vue&type=script&lang=js&"
export * from "./UserRoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleSelect.vue?vue&type=style&index=0&id=2aa7a696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7a696",
  null
  
)

export default component.exports